import React, { useEffect, useState } from "react";
import { createSearchParams, useLocation, useNavigate } from "react-router-dom";
import HomeFragment from "../fragment/HomeFragment";
import ModalRedeem from "../components/Modal/ModalRedeem";
import { ReactComponent as GearIcon } from "../assets/icons/settings.svg";
import { ReactComponent as BellIcon } from "../assets/icons/bell.svg";
import LogoDompetKartini from "../assets/images/dompet-horz.png";
import { Link } from "react-router-dom";
import InboxFragment from "../fragment/InboxFragment";
import EwalletFragment from "../fragment/EwalletFragment";
import withAuth from "../components/withAuth";
import GenerateFragment from "../fragment/GenerateFragment";
import { useTranslation } from "react-i18next";
import useAnalytics from "../hooks/useAnalytics";
import { Helmet } from "react-helmet";
import { useAuth } from "../components/auth/authContext";

const Home = () => {
  useAnalytics();
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const { userData } = useAuth();
  const [menu, setMenu] = useState("Home");
  const [showModalRedeem, setShowModalRedeem] = useState(false);
  const [user] = useState(JSON.parse(localStorage.getItem("dompet_user")));
  const [dataOutlet] = useState(
    JSON.parse(localStorage.getItem("dompet_detail_outlet")),
  );

  const [navbarBackground, setNavbarBackground] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 50) {
        setNavbarBackground(true);
      } else {
        setNavbarBackground(false);
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const NavigationData = [
    {
      name: "Home",
      label: t("navBar.home"),
      icon: (
        <svg
          width="23"
          height="22"
          viewBox="0 0 23 22"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M9.7002 21V13.6C9.7002 13.0399 9.7002 12.7599 9.80919 12.546C9.90506 12.3578 10.058 12.2049 10.2462 12.109C10.4601 12 10.7401 12 11.3002 12H14.1002C14.6602 12 14.9403 12 15.1542 12.109C15.3423 12.2049 15.4953 12.3578 15.5912 12.546C15.7002 12.7599 15.7002 13.0399 15.7002 13.6V21M11.7179 2.764L4.93559 8.03912C4.48222 8.39175 4.25553 8.56806 4.09222 8.78886C3.94756 8.98444 3.8398 9.20478 3.77422 9.43905C3.7002 9.70352 3.7002 9.9907 3.7002 10.5651V17.8C3.7002 18.9201 3.7002 19.4801 3.91818 19.908C4.10993 20.2843 4.41589 20.5903 4.79221 20.782C5.22004 21 5.78009 21 6.9002 21H18.5002C19.6203 21 20.1804 21 20.6082 20.782C20.9845 20.5903 21.2905 20.2843 21.4822 19.908C21.7002 19.4801 21.7002 18.9201 21.7002 17.8V10.5651C21.7002 9.9907 21.7002 9.70352 21.6262 9.43905C21.5606 9.20478 21.4528 8.98444 21.3082 8.78886C21.1449 8.56806 20.9182 8.39175 20.4648 8.03913L13.6825 2.764C13.3312 2.49075 13.1555 2.35412 12.9615 2.3016C12.7904 2.25526 12.61 2.25526 12.4388 2.3016C12.2449 2.35412 12.0692 2.49075 11.7179 2.764Z"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      ),
      hasAccess: false,
    },
    {
      name: "E-Wallet",
      label: t("navBar.ewallet"),
      icon: (
        <svg
          width="23"
          height="22"
          viewBox="0 0 23 22"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M16.6006 14H16.6106M3.10059 5V19C3.10059 20.1046 3.99602 21 5.10059 21H19.1006C20.2052 21 21.1006 20.1046 21.1006 19V9C21.1006 7.89543 20.2052 7 19.1006 7L5.10059 7C3.99602 7 3.10059 6.10457 3.10059 5ZM3.10059 5C3.10059 3.89543 3.99602 3 5.10059 3H17.1006M17.1006 14C17.1006 14.2761 16.8767 14.5 16.6006 14.5C16.3244 14.5 16.1006 14.2761 16.1006 14C16.1006 13.7239 16.3244 13.5 16.6006 13.5C16.8767 13.5 17.1006 13.7239 17.1006 14Z"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      ),
      hasAccess: false,
    },
    {
      name: "Redeem",
      label: t("navBar.redeem"),
      icon: (
        <svg
          width="23"
          height="23"
          viewBox="0 0 23 22"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M10.5 8V7M10.5 12.5V11.5M10.5 17V16M5.7 4H19.3C20.4201 4 20.9802 4 21.408 4.21799C21.7843 4.40973 22.0903 4.71569 22.282 5.09202C22.5 5.51984 22.5 6.0799 22.5 7.2V8.5C20.567 8.5 19 10.067 19 12C19 13.933 20.567 15.5 22.5 15.5V16.8C22.5 17.9201 22.5 18.4802 22.282 18.908C22.0903 19.2843 21.7843 19.5903 21.408 19.782C20.9802 20 20.4201 20 19.3 20H5.7C4.5799 20 4.01984 20 3.59202 19.782C3.21569 19.5903 2.90973 19.2843 2.71799 18.908C2.5 18.4802 2.5 17.9201 2.5 16.8V15.5C4.433 15.5 6 13.933 6 12C6 10.067 4.433 8.5 2.5 8.5V7.2C2.5 6.0799 2.5 5.51984 2.71799 5.09202C2.90973 4.71569 3.21569 4.40973 3.59202 4.21799C4.01984 4 4.5799 4 5.7 4Z"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      ),
      hasAccess: false,
    },
    {
      name: "pajangan",
      label: t("navBar.display"),
      icon: (
        <svg
          width="23"
          height="22"
          viewBox="0 0 23 22"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M9.30039 3H5.50039C4.94034 3 4.66031 3 4.4464 3.10899C4.25824 3.20487 4.10526 3.35785 4.00938 3.54601C3.90039 3.75992 3.90039 4.03995 3.90039 4.6V8.4C3.90039 8.96005 3.90039 9.24008 4.00938 9.45399C4.10526 9.64215 4.25824 9.79513 4.4464 9.89101C4.66031 10 4.94034 10 5.50039 10H9.30039C9.86044 10 10.1405 10 10.3544 9.89101C10.5425 9.79513 10.6955 9.64215 10.7914 9.45399C10.9004 9.24008 10.9004 8.96005 10.9004 8.4V4.6C10.9004 4.03995 10.9004 3.75992 10.7914 3.54601C10.6955 3.35785 10.5425 3.20487 10.3544 3.10899C10.1405 3 9.86044 3 9.30039 3Z"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M20.3004 3H16.5004C15.9403 3 15.6603 3 15.4464 3.10899C15.2582 3.20487 15.1053 3.35785 15.0094 3.54601C14.9004 3.75992 14.9004 4.03995 14.9004 4.6V8.4C14.9004 8.96005 14.9004 9.24008 15.0094 9.45399C15.1053 9.64215 15.2582 9.79513 15.4464 9.89101C15.6603 10 15.9403 10 16.5004 10H20.3004C20.8604 10 21.1405 10 21.3544 9.89101C21.5425 9.79513 21.6955 9.64215 21.7914 9.45399C21.9004 9.24008 21.9004 8.96005 21.9004 8.4V4.6C21.9004 4.03995 21.9004 3.75992 21.7914 3.54601C21.6955 3.35785 21.5425 3.20487 21.3544 3.10899C21.1405 3 20.8604 3 20.3004 3Z"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M20.3004 14H16.5004C15.9403 14 15.6603 14 15.4464 14.109C15.2582 14.2049 15.1053 14.3578 15.0094 14.546C14.9004 14.7599 14.9004 15.0399 14.9004 15.6V19.4C14.9004 19.9601 14.9004 20.2401 15.0094 20.454C15.1053 20.6422 15.2582 20.7951 15.4464 20.891C15.6603 21 15.9403 21 16.5004 21H20.3004C20.8604 21 21.1405 21 21.3544 20.891C21.5425 20.7951 21.6955 20.6422 21.7914 20.454C21.9004 20.2401 21.9004 19.9601 21.9004 19.4V15.6C21.9004 15.0399 21.9004 14.7599 21.7914 14.546C21.6955 14.3578 21.5425 14.2049 21.3544 14.109C21.1405 14 20.8604 14 20.3004 14Z"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M9.30039 14H5.50039C4.94034 14 4.66031 14 4.4464 14.109C4.25824 14.2049 4.10526 14.3578 4.00938 14.546C3.90039 14.7599 3.90039 15.0399 3.90039 15.6V19.4C3.90039 19.9601 3.90039 20.2401 4.00938 20.454C4.10526 20.6422 4.25824 20.7951 4.4464 20.891C4.66031 21 4.94034 21 5.50039 21H9.30039C9.86044 21 10.1405 21 10.3544 20.891C10.5425 20.7951 10.6955 20.6422 10.7914 20.454C10.9004 20.2401 10.9004 19.9601 10.9004 19.4V15.6C10.9004 15.0399 10.9004 14.7599 10.7914 14.546C10.6955 14.3578 10.5425 14.2049 10.3544 14.109C10.1405 14 9.86044 14 9.30039 14Z"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      ),
      hasAccess: false,
      disabled: true,
    },

    {
      name: "generate",
      label: "Generate QR",
      icon: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          width="23"
          height="22"
          viewBox="0 0 23 22"
          strokeWidth={1.5}
          stroke="currentColor"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M3.75 4.875c0-.621.504-1.125 1.125-1.125h4.5c.621 0 1.125.504 1.125 1.125v4.5c0 .621-.504 1.125-1.125 1.125h-4.5A1.125 1.125 0 0 1 3.75 9.375v-4.5ZM3.75 14.625c0-.621.504-1.125 1.125-1.125h4.5c.621 0 1.125.504 1.125 1.125v4.5c0 .621-.504 1.125-1.125 1.125h-4.5a1.125 1.125 0 0 1-1.125-1.125v-4.5ZM13.5 4.875c0-.621.504-1.125 1.125-1.125h4.5c.621 0 1.125.504 1.125 1.125v4.5c0 .621-.504 1.125-1.125 1.125h-4.5A1.125 1.125 0 0 1 13.5 9.375v-4.5Z"
          />
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M6.75 6.75h.75v.75h-.75v-.75ZM6.75 16.5h.75v.75h-.75v-.75ZM16.5 6.75h.75v.75h-.75v-.75ZM13.5 13.5h.75v.75h-.75v-.75ZM13.5 19.5h.75v.75h-.75v-.75ZM19.5 13.5h.75v.75h-.75v-.75ZM19.5 19.5h.75v.75h-.75v-.75ZM16.5 16.5h.75v.75h-.75v-.75Z"
          />
        </svg>
      ),
      hasAccess: true,
    },
    {
      name: "generate",
      label: "Refer QR",
      icon: (
        <svg
          width="23"
          height="22"
          viewBox="0 0 23 22"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M7.2998 12H12.2998V17M3.3098 12H3.2998M8.3098 17H8.2998M12.3098 21H12.2998M21.3098 12H21.2998M3.2998 17H4.7998M15.7998 12H17.7998M3.2998 21H8.2998M12.2998 2V8M17.8998 21H19.6998C20.2599 21 20.5399 21 20.7538 20.891C20.942 20.7951 21.0949 20.6422 21.1908 20.454C21.2998 20.2401 21.2998 19.9601 21.2998 19.4V17.6C21.2998 17.0399 21.2998 16.7599 21.1908 16.546C21.0949 16.3578 20.942 16.2049 20.7538 16.109C20.5399 16 20.2599 16 19.6998 16H17.8998C17.3398 16 17.0597 16 16.8458 16.109C16.6577 16.2049 16.5047 16.3578 16.4088 16.546C16.2998 16.7599 16.2998 17.0399 16.2998 17.6V19.4C16.2998 19.9601 16.2998 20.2401 16.4088 20.454C16.5047 20.6422 16.6577 20.7951 16.8458 20.891C17.0597 21 17.3398 21 17.8998 21ZM17.8998 8H19.6998C20.2599 8 20.5399 8 20.7538 7.89101C20.942 7.79513 21.0949 7.64215 21.1908 7.45399C21.2998 7.24008 21.2998 6.96005 21.2998 6.4V4.6C21.2998 4.03995 21.2998 3.75992 21.1908 3.54601C21.0949 3.35785 20.942 3.20487 20.7538 3.10899C20.5399 3 20.2599 3 19.6998 3H17.8998C17.3398 3 17.0597 3 16.8458 3.10899C16.6577 3.20487 16.5047 3.35785 16.4088 3.54601C16.2998 3.75992 16.2998 4.03995 16.2998 4.6V6.4C16.2998 6.96005 16.2998 7.24008 16.4088 7.45399C16.5047 7.64215 16.6577 7.79513 16.8458 7.89101C17.0597 8 17.3398 8 17.8998 8ZM4.8998 8H6.6998C7.25986 8 7.53988 8 7.7538 7.89101C7.94196 7.79513 8.09494 7.64215 8.19081 7.45399C8.2998 7.24008 8.2998 6.96005 8.2998 6.4V4.6C8.2998 4.03995 8.2998 3.75992 8.19081 3.54601C8.09494 3.35785 7.94196 3.20487 7.7538 3.10899C7.53988 3 7.25986 3 6.6998 3H4.8998C4.33975 3 4.05973 3 3.84581 3.10899C3.65765 3.20487 3.50467 3.35785 3.4088 3.54601C3.2998 3.75992 3.2998 4.03995 3.2998 4.6V6.4C3.2998 6.96005 3.2998 7.24008 3.4088 7.45399C3.50467 7.64215 3.65765 7.79513 3.84581 7.89101C4.05973 8 4.33975 8 4.8998 8Z"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      ),
      hasAccess: false,
      // disabled: true,
    },
  ];

  return (
    <>
      <Helmet>
        <title>{menu ? `${menu} | Dompet Kartini` : ""}</title>
      </Helmet>
      {/* {window.innerWidth > 768 && <Navigate to="/require" />} */}

      <div className="no-scrollbar bg-home relative overflow-y-scroll ">
        <div className="fixed bottom-0 z-50 w-screen bg-white shadow-2xl">
          <ul className="mx-auto grid max-w-screen-xl grid-cols-5 justify-items-center py-3 text-sm font-medium">
            {NavigationData.filter((item) => !item.hasAccess).map(
              (menuItem, index) => (
                <li key={index}>
                  <button
                    className={`${
                      location.search
                        ? location.search === `?menu=${menuItem.name}`
                          ? "text-soft-red-500"
                          : "text-monochrome-300"
                        : menu === menuItem.name
                          ? "text-soft-red-500"
                          : "text-monochrome-300"
                    } flex flex-col items-center justify-between gap-2 whitespace-nowrap`}
                    onClick={() => {
                      if (menuItem.name === "Redeem") {
                        setShowModalRedeem(true);
                      } else {
                        setMenu(menuItem.name);
                        navigate("/");
                        if (menuItem.name !== "Home") {
                          navigate({
                            pathname: "/",
                            search: createSearchParams({
                              menu: menuItem.name,
                            }).toString(),
                          });
                        }
                      }
                    }}
                    disabled={menuItem.disabled}
                  >
                    {menuItem.icon}
                    <span className="text-2xs">{menuItem.label}</span>
                  </button>
                </li>
              ),
            )}
          </ul>
        </div>
        <div
          className={`${navbarBackground ? "bg-white" : "bg-transparent"} fixed top-0 z-50 w-full p-4 transition-colors duration-300`}
        >
          <div className="mx-auto flex max-w-screen-xl flex-col space-y-4">
            <div className="flex items-center justify-between ">
              <div className="block">
                <img
                  className="w-28"
                  src={LogoDompetKartini}
                  alt="logo-kartini-color"
                />
              </div>
              <div className="flex items-center gap-4 text-monochrome-400">
                <Link to="/notification">
                  <BellIcon />
                </Link>
                <Link to="/settings">
                  <GearIcon />
                </Link>
              </div>
            </div>
          </div>
        </div>
        <div className="max-w-screen mx-auto min-h-dvh px-4 pb-24 pt-24 xl:px-0 ">
          {menu === "Home" && !location.search ? (
            <HomeFragment userData={userData} />
          ) : menu === "E-Wallet" || location.search === "?menu=E-Wallet" ? (
            <EwalletFragment />
          ) : menu === "generate" || location.search === "?menu=generate" ? (
            <GenerateFragment />
          ) : (
            menu === "inbox" && <InboxFragment />
          )}
        </div>
      </div>
      <ModalRedeem isOpen={showModalRedeem} setIsOpen={setShowModalRedeem} />
    </>
  );
};

export default withAuth(Home);
